import { useState } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import {
  VIPSDataServiceURL,
  requestOptions,
} from "../../Constants/GlobalConstant";
import { getMessage } from "../../CommonFuntion/messages";
import { getVendorIdFromSession } from "../../CommonFuntion/TableBodyFormikHelper";
import SnackbarAlert from "./SnackbarAlert";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const CatalogueOutTableDropdownField = (props) => {
  const [validOrderMessage, setvalidOrderMessage] = useState("");
  const [openToolbar, setOpenToolbar] = useState(false);
  const [options, setOptions] = useState(props.keyValues || []);
  const handleCloseToolbar = () => {
    setOpenToolbar(false);
  };

  const {
    name,
    lastKey,
    catId,
    catDropDown,
    schemaResult,
    keyIndex,
    SetcatalogueChildOptn,
    user_id,
    store_grp,
    label,
    tagName,
    validation = {},
  } = props;

  const itemID = schemaResult?.[1]?.itemId;
  const { setFieldValue, values } = useFormikContext();
  const id = `${tagName}-select`;

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setFieldValue(name, selectedValue);

    if (!selectedValue) {
      SetcatalogueChildOptn("");
      return;
    }

    let changeDropDownVal = { ...catDropDown };
    changeDropDownVal[keyIndex] = selectedValue;

    if (lastKey === true) {
      // Last key — fetch catalogue header data
      let getCatalogueHeaderDataApiUrl =
        `${VIPSDataServiceURL}/Catalogue/GetCatalogueHeaderData?catId=${catId}` +
        `&pageID=${schemaResult?.[0]?.pageId}`; // Assuming pageId is in schemaResult[0]
      const entriesDropDown = Object.entries(changeDropDownVal);
      entriesDropDown?.forEach(([key, value]) => {
        getCatalogueHeaderDataApiUrl =
          getCatalogueHeaderDataApiUrl + `&key${parseInt(key)}=${value}`;
      });
      getCatalogueHeaderDataApiUrl =
        getCatalogueHeaderDataApiUrl +
        `&storeGrp=${store_grp}` +
        `&userId=${user_id}`;

      fetch(getCatalogueHeaderDataApiUrl, requestOptions)
        .then((response) => response.json())
        .then((data) => {

          const labelCatalogueSchemaType = schemaResult.filter(
            (x) => x.prefix === "CAT" && x.keyIndex === 0
          );

          if (data.catData.length > 0) {
            const requiredData = data.catData;
            requiredData.forEach((field) => {
              field.forEach((x) => {
                const labelCatalogueField = labelCatalogueSchemaType.find(
                  (y) => y.catFieldId === x.ID
                )?.fieldName;
                if (labelCatalogueField !== undefined) {
                  setFieldValue(labelCatalogueField, x.Value);
                }
              });
            });
            setFieldValue(name, selectedValue);
            SetcatalogueChildOptn(data.catData);
          } else {
            setvalidOrderMessage(data.errorDescription);
            setOpenToolbar(true);
            const catalougeFields = schemaResult.filter(
              (y) => y.schemaType === 24
            );
            if (catalougeFields.length > 0) {
              catalougeFields.forEach((x) => {
                setFieldValue(x.fieldName, "");
              });
            }
            SetcatalogueChildOptn("");
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    } else {
      // Not last key — fetch child key values for the next dropdown
      const vendorId = getVendorIdFromSession();
      let getCatalogueKeyValuesApiUrl =
        `${VIPSDataServiceURL}/Catalogue/GetCatalogueKeyValues?catId=${catId}` +
        `&KeyNo=${keyIndex + 1}`;
      const entriesDropDown = Object.entries(changeDropDownVal);
      entriesDropDown?.forEach(([key, value]) => {
        getCatalogueKeyValuesApiUrl =
          getCatalogueKeyValuesApiUrl + `&key${parseInt(key)}=${value}`;
      });
      getCatalogueKeyValuesApiUrl += `&vendorId=${encodeURIComponent(vendorId)}`;

      fetch(getCatalogueKeyValuesApiUrl, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            // Child dropdown options will be picked up by the next key's component
            // via its own keyValues prop from schema
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>
        <div className="control-bottom-border">
          <FormControl>
            <Select
              id={id}
              name={name}
              value={values?.[name] || ""}
              onChange={handleChange}
              variant="standard"
              displayEmpty
              style={{
                fontSize: "12px",
                width: "200px",
              }}
              data-testid="CatalogueOutTableDropdownField"
            >
              <MenuItem value="">
                <em></em>
              </MenuItem>
              {(options || []).map((item, index) => (
                <MenuItem style={{
                  fontSize: "12px",
                }} key={index} value={item.label || item.value || item}>
                  {item.label || item.value || item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
      <SnackbarAlert
        open={openToolbar}
        message={validOrderMessage}
        severity="error"
        onClose={handleCloseToolbar}
      />
    </>
  );
};

export default CatalogueOutTableDropdownField;
